import React, { useEffect } from 'react';
import { getProductEntityName } from '../Product.config';

import { useAssignDesignInputDesignOutput } from '../Product.hooks';
import {
  ProductDesignOutput,
  BaseProductAssignDialogProps
} from '../Product.interface';
import AssignDesignOutputDialog from './AssignDesignOutputDialog';

export type DesignInputAssignDesignOutputDialogProps = BaseProductAssignDialogProps<'designInputId'>;

const DesignInputAssignDesignOutputDialog: React.FC<DesignInputAssignDesignOutputDialogProps> = (
  props: DesignInputAssignDesignOutputDialogProps
) => {
  const {
    open,
    productId,
    designInputId,
    selectedItems,
    onCancel,
    onError,
    onAssigned
  } = props;
  const {
    updatedProductDesignInput,
    isAssigning,
    error: assignError,
    assignDesignOutputs
  } = useAssignDesignInputDesignOutput(productId, designInputId);

  // handle notification to parent after assigning
  useEffect(() => {
    if (updatedProductDesignInput) {
      onAssigned?.(updatedProductDesignInput);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedProductDesignInput]);

  useEffect(() => {
    if (assignError) {
      onError?.(assignError);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assignError]);

  return (
    <AssignDesignOutputDialog
      {...{ open, productId, selectedItems, onCancel, onError }}
      isLoading={isAssigning}
      contentText={`Search for ${getProductEntityName(
        'designOutput'
      )} to assign to the ${getProductEntityName('designInput')}.`}
      onSubmit={(designOutputs: ProductDesignOutput[]) => {
        assignDesignOutputs({
          designOutputIds: designOutputs.map(
            (designOutput: ProductDesignOutput) => designOutput.id
          )
        });
      }}
    />
  );
};

export default DesignInputAssignDesignOutputDialog;
